import MuiMenuItem from '@material-ui/core/MenuItem';
import MuiMenuList from '@material-ui/core/MenuList';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@monorepo/shared/componentsV2/Button/IconButton';
import {
  ModalWizard,
  ModalWizardProps,
} from '@monorepo/shared/componentsV2/modalWizard/modalWizard';
import { contentPadding } from '@monorepo/shared/styles/layout';
import { bodyRegular, header3 } from '@monorepo/shared/styles/text';
import TextIndentIcon from '@svg/text-indent.svg';
import TextOutdentIcon from '@svg/text-outdent.svg';
import React from 'react';
import styled from 'styled-components';
import { LogEntriesFormValues } from './conversionHelpers';

function LogEntriesModalWizard(
  props: ModalWizardProps<LogEntriesFormValues, Partial<LogEntriesFormValues>>,
) {
  return <ModalWizard<LogEntriesFormValues> {...props} />;
}

export const StyledModalWizard = styled(LogEntriesModalWizard)`
  & .MuiPaper-root.MuiDialog-paper {
    overflow: hidden;
  }

  & .MuiDialogContent-root {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 16rem;
`;

export const SubContainer = styled.div`
  width: 100%;
  max-width: 30rem;
`;

export const SubContainerTitle = styled.div`
  ${header3}
`;

export const FileStatus = styled.div`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.gray666};
`;

export const FileListContainerHeader = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1rem;
`;

export const FileListContainerHeaderTitle = styled.div`
  ${bodyRegular}
  font-weight: 600;
  color: ${({ theme }) => theme.colors.gray666};
`;

export const FileListScrollContainer = styled.div`
  max-height: 20rem;
  overflow-y: auto;
`;

export const OutlinedFileContainer = styled.div`
  display: flex;
  gap: 0.25rem;
  align-items: center;
  min-height: 3.5rem;
  max-height: 5rem;
  padding: 0.5rem;
  margin-top: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.grayddd};
  border-radius: 4px;
`;

export const DeleteButton = styled(IconButton)`
  margin-right: 0.25rem;
  margin-left: auto;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ErrorSymbol = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: fit-content;
  padding: 8px;
  margin-right: 0;
  margin-left: auto;

  svg {
    width: 22px;
    height: 22px;
    margin: 0;
    fill: ${({ theme }) => theme.colors.darkRed};
  }
`;

export const StatusIndicator = styled.div`
  margin: 0.5rem 0.5rem 0.5rem 0.25rem;
`;

export const StyledCheckIcon = styled(CheckIcon)`
  fill: ${({ theme }) => theme.colors.green};
`;

export const StyledErrorIcon = styled(CloseIcon)`
  fill: ${({ theme }) => theme.colors.darkRed};
`;

export const FileNameAndStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
  margin-left: 0.25rem;
`;

export const FileName = styled.div`
  margin-bottom: 0.25rem;
  font-weight: 700;
`;

export const CurrentEntrySubtitle = styled.div`
  margin-top: -12px;
  font-size: 16px;
`;

export const CurrentEntrySubtitleText = styled.span`
  position: relative;
  top: 1px;
`;

export const CurrentEntrySubtitleFileName = styled.span`
  position: relative;
  top: 1px;
  padding-left: 0.5rem;
`;

export const StyledTextIndentIcon = styled(TextIndentIcon)`
  && {
    width: 20px;
    margin-right: -2px;
    margin-left: -2px;
  }
`;

export const StyledTextOutdentIcon = styled(TextOutdentIcon)`
  && {
    width: 16px;
  }
`;

export const LogEntriesNavigationSidebar = styled(MuiMenuList)`
  width: 8rem;
  padding-top: 4px;
  overflow: auto;
  background-color: ${({ theme }) => theme.colors.grayf4};
  border-right: ${({ theme }) => `1px solid ${theme.colors.grayddd}`};
`;

export const EntryNavigationButton = styled(MuiMenuItem)<{
  $isActive?: boolean;
}>`
  justify-content: start;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: ${({ $isActive }) => ($isActive ? 700 : 'unset')};
  color: ${({ $isActive, theme }) =>
    $isActive ? theme.colors.builderBlue : 'unset'};
  text-transform: none;
`;

export const MainLayoutContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  gap: 8px;
  width: 100%;
  height: 100%;
  min-height: 0;
  padding-right: 8px;
`;

export const LeftSideContainer = styled.div`
  flex-basis: 0;
  flex-grow: 1;
`;

export const RightSideContainer = styled.div`
  flex-basis: 0;
  flex-grow: 1;
`;

export const LogEntriesEditFormContainer = styled(LeftSideContainer)`
  display: flex;
  overflow: hidden;
  border: ${({ theme }) => `1px solid ${theme.colors.grayddd}`};
  border-radius: 4px;
`;

export const SingleEditLogEntryForm = styled.div`
  ${contentPadding}
  width: 100%;
  overflow: auto;
`;

export const LogEntriesDocumentContainer = styled(RightSideContainer)`
  overflow: auto;
  border: ${({ theme }) => `1px solid ${theme.colors.grayddd}`};
  border-radius: 4px;
`;
